import dateService from '../services/util/dateService'
import loggingService from '../services/util/loggingService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'projectOrganizationViewOnlyService'
var path = '/ProjectOrganizationViewOnly/'
var isDebug = false

const save = (http, projectId, organizationId) => {
    loggingService.log(isDebug, serviceName, 'postProjectOrganizationViewOnly')

    return http.post(`${path}Save?projectId=${projectId}&organizationId=${organizationId}`)
}

const getList = (http, projectId) => {
    loggingService.log(isDebug, serviceName, 'getProjectOrganizationViewOnly')

    return http.get(`${path}GetList?projectId=${projectId}`).then(res => {
        loggingService.log(isDebug, serviceName, 'getProjectOrganizationViewOnly.then')

        _.forEach(res.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
        })

        return res
    })
}

const remove = (http, projectOrganizationViewOnlyId) => {
    return http.delete(`${path}Delete?projectOrganizationViewOnlyId=${projectOrganizationViewOnlyId}`)
}

export default {
    save: save,
    getList: getList,
    remove: remove
}



// WEBPACK FOOTER //
// ./src/services/projectOrganizationViewOnlyService.js